import { Module, forwardRef } from '@nestjs/common';
import { MongooseModule } from '@nestjs/mongoose';
import { APP_PIPE } from '@nestjs/core';
import { ValidationPipe } from '@nestjs/common';

import { InventoryService } from './services/inventory.service';
import { RecalculateRevenueService } from './services/recalculate-revenue.service';
import { InventoryController } from './controllers/inventory.controller';
import { StockMovement, StockMovementSchema } from './schemas/stock-movement.schema';
import { Expense, ExpenseSchema } from './schemas/expense.schema';
import { Revenue, RevenueSchema } from './schemas/revenue.schema';
import { ProfitReport, ProfitReportSchema } from './schemas/profit-report.schema';
import { Product, ProductSchema } from '../product/schemas/product.schema';
import { Order, OrderSchema } from '../order/schemas/order.schema';

// Circular dependencies
import { ProductModule } from '../product/product.module';
import { OrderModule } from '../order/order.module';

@Module({
  imports: [
    MongooseModule.forFeature([
      { name: StockMovement.name, schema: StockMovementSchema },
      { name: Expense.name, schema: ExpenseSchema },
      { name: Revenue.name, schema: RevenueSchema },
      { name: ProfitReport.name, schema: ProfitReportSchema },
      { name: Product.name, schema: ProductSchema },
      { name: Order.name, schema: OrderSchema }
    ]),
    forwardRef(() => ProductModule),
    forwardRef(() => OrderModule),
  ],
  controllers: [InventoryController],
  providers: [
    InventoryService, 
    RecalculateRevenueService,
    {
      provide: APP_PIPE,
      useClass: ValidationPipe,
    },
  ],
  exports: [InventoryService, RecalculateRevenueService, MongooseModule],
})
export class InventoryModule {} 